<div class="map-page">
  <info-page-header label="Mapa"></info-page-header>
  <!-- Google Map -->
  <google-map
    class="map-container"
    width="100%"
    [center]="center"
    [zoom]="zoom">

    <map-marker
      *ngIf="reservationPosition"
      [position]="reservationPosition"
      [options]="reservationMarkerOptions"
      title="Tu Reserva">
    </map-marker>

    <ng-container *ngFor="let marker of markers; let i = index">
      <map-marker
        #m="mapMarker"
        [position]="{ lat: +marker.lat, lng: +marker.lng }"
        [options]="getMarkerOptions(marker)"
        [title]="marker.title"
        (mapClick)="openInfoWindow(i, m, iw)">
      </map-marker>

      <map-info-window
        #iw="mapInfoWindow"
        [position]="{ lat: +marker.lat, lng: +marker.lng }">

        <div class="info-window-content">
          <!-- Imagen del marker -->
          <div class="info-image" *ngIf="getMarkerImage(marker)">
            <img [src]="getMarkerImage(marker)" [alt]="marker.title" />
          </div>
          <h3 class="info-title">{{ marker.title }}</h3>
        </div>
      </map-info-window>
    </ng-container>
  </google-map>

  <square-button
    class="navegate-button"
    label="Navegar"
    (click)="navigateToSelectedMarker()"
    [disabled]="!selectedMarker">
  </square-button>

</div>
